var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g-signin-button',{attrs:{"params":_vm.googleSignInParams},on:{"success":_vm.onGoogleSignInSuccess,"error":_vm.onGoogleSignInError}},[_c('button',{staticClass:"btn btn--tondo btn-block my-2"},[_vm._v(" Google")])])}
var staticRenderFns = []

export { render, staticRenderFns }